// extracted by mini-css-extract-plugin
export default {"container":"RealEstateObjectCard_container__qCfBv","body":"RealEstateObjectCard_body__aefcQ"};